export default __webpack_public_path__ + "static/media/wa-1718.b400c2df.jpg";